const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || 'http://localhost:1337'

export class StrapiApiError extends Error {
    constructor(message, { status, name, details } = {}) {
        super(message)
        this.name = 'StrapiApiError'
        this.status = status
        this.strapiErrorName = name
        this.details = details
    }
}

function buildQuery(params) {
    const query = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) return
        if (Array.isArray(value)) {
            value.forEach(v => query.append(key, v))
        } else {
            query.append(key, value)
        }
    })
    return query.toString()
}

// Thin fetch wrapper for the Strapi REST API: injects `?locale=`, normalizes
// network/HTTP/Strapi error shapes into StrapiApiError so slices can surface
// `error` state instead of swallowing failures silently.
export async function strapiFetch(path, { locale, params = {}, ...fetchOptions } = {}) {
    const query = buildQuery(locale ? { ...params, locale } : params)
    const url = `${STRAPI_URL}${path}${query ? `?${query}` : ''}`

    let response
    try {
        response = await fetch(url, {
            headers: { 'Content-Type': 'application/json', ...(fetchOptions.headers || {}) },
            ...fetchOptions,
        })
    } catch (networkError) {
        throw new StrapiApiError(networkError.message, { status: 0 })
    }

    let json = null
    try {
        json = await response.json()
    } catch (parseError) {
        // empty/non-JSON body (e.g. 204 No Content)
    }

    if (!response.ok) {
        const err = json && json.error
        throw new StrapiApiError((err && err.message) || response.statusText, {
            status: (err && err.status) || response.status,
            name: err && err.name,
            details: err && err.details,
        })
    }

    return json
}

// Strapi v5 media fields are flat objects with a relative `url`. Components
// only ever read `.file_url` off a media field, so normalize down to that.
export function normalizeMedia(media) {
    if (!media) return null
    if (Array.isArray(media)) return media.map(normalizeMedia).filter(Boolean)
    if (!media.url) return null
    return {
        file_url: /^https?:\/\//.test(media.url) ? media.url : `${STRAPI_URL}${media.url}`,
    }
}

// `shared.seo` -> the {title, meta_keyword, meta_description} shape every
// page's <MetaTags> already reads, with the same "Aura Design" fallback that
// was previously baked into each page's local loadSeo() when banners was null.
export function mapSeo(seo, fallback = 'Aura Design') {
    if (!seo) {
        return { title: fallback, meta_keyword: fallback, meta_description: fallback }
    }
    return {
        title: seo.metaTitle || fallback,
        meta_keyword: seo.metaKeyword || fallback,
        meta_description: seo.metaDescription || fallback,
    }
}

export { STRAPI_URL }


// Fungsi untuk mengambil daftar Aura Design dari Strapi
export async function getAuraDesigns(params = {}) {
    // Memanggil API /api/aura-designs dengan query populate=* agar media/gambar ikut terbawa
    const data = await strapiFetch('/api/aura-designs', {
        params: {
            populate: '*',
            ...params,
        },
    });

    return data;
}